import React, { useState } from "react";
import { HiArrowSmUp, HiArrowSmDown } from "react-icons/hi";
import LoginDialog from "components/card/LoginDialog";
import VerifyEmailDialog from "components/card/VerifyEmailDialog";

const VoteButtonsMini = ({ state = "", onChange, currentUser }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenVerifyEmailDialog, setIsOpenVerifyEmailDialog] = useState(false);
  const [agreeHovered, setAgreeHovered] = useState(false);
  const [disagreeHovered, setDisagreeHovered] = useState(false);
  const activeAgreeClass = "w-[50px] text-[#005845] bg-[#EDFFFB]";
  const activeAgreeGradientClass = "bg-gradient-to-l from-[#00BE95]";
  const activeDisagreeClass = "w-[50px] text-[#84003C] bg-[#FFEDF5]";
  const activeDisagreeGradientClass = "bg-gradient-to-r from-[#84003C]";
  const inactiveAgreeClass =
    "w-[50px] text-gray-400 hover:text-[#005845] hover:bg-[#EDFFFB]";
  const inactiveAgreeGradientClass = "bg-gradient-to-l from-[#00BE95]/40";
  const inactiveDisagreeClass =
    "w-[50px] text-gray-400 hover:text-[#84003C] hover:bg-[#FFEDF5]";
  const inactiveDisagreeGradientClass = "bg-gradient-to-r from-[#84003C]/40";

  return (
    <div className="flex justify-end items-center cursor-pointer">
      <button
        title="Համաձայն չեմ"
        onMouseEnter={() => setDisagreeHovered(true)}
        onMouseLeave={() => setDisagreeHovered(false)}
        onClick={() => {
          if (!currentUser) {
            setIsOpen(true);
          }
          if (currentUser && !currentUser.emailVerified) {
            setIsOpenVerifyEmailDialog(true);
          }
          if (currentUser && currentUser.emailVerified) {
            onChange("disagree");
          }
        }}
        className={`py-[2px] pl-[2px] rounded-l-full ${state === "disagree" && !agreeHovered ? activeDisagreeGradientClass : inactiveDisagreeGradientClass}`}
      >
        <div className="flex items-center gap-10 px-[4px] bg-white rounded-l-full">
          <div
            className={`h-[50px] ${state === "disagree" && !agreeHovered ? activeDisagreeClass : inactiveDisagreeClass} flex items-center justify-center gap-2 rounded-full transition-all duration-500`}
          >
            <HiArrowSmDown size={24} color="" className="" />
          </div>
        </div>
      </button>
      <span className="mb-1">|</span>
      <button
        title="Համաձայն եմ"
        onMouseEnter={() => setAgreeHovered(true)}
        onMouseLeave={() => setAgreeHovered(false)}
        className={`py-[2px] pr-[2px] rounded-r-full ${state === "agree" && !disagreeHovered ? activeAgreeGradientClass : inactiveAgreeGradientClass}`}
        onClick={() => {
          if (!currentUser) {
            setIsOpen(true);
          }
          if (currentUser && !currentUser.emailVerified) {
            setIsOpenVerifyEmailDialog(true);
          }
          if (currentUser && currentUser.emailVerified) {
            onChange("agree");
          }
        }}
      >
        <div className="flex items-center gap-10 px-[4px] bg-white rounded-r-full">
          <div
            className={`h-[50px] ${state === "agree" && !disagreeHovered ? activeAgreeClass : inactiveAgreeClass} flex items-center justify-center gap-2 rounded-full transition-all duration-500`}
          >
            <HiArrowSmUp size={24} />
          </div>
        </div>
      </button>
      <LoginDialog isOpen={isOpen} handleClose={() => setIsOpen(false)} />
      <VerifyEmailDialog
        isOpen={isOpenVerifyEmailDialog}
        handleClose={() => setIsOpenVerifyEmailDialog(false)}
      />
    </div>
  );
};

export default VoteButtonsMini;
